import axios from "axios";
import apis from "./apis";
import { Toast } from "../Components";
import { getServerOrigin } from "./utils";

const getOrigin = (url) => {
	let server_url = getServerOrigin();
	if (url.startsWith("/")) {
		return server_url + url;
	} else if (url.startsWith("http")) {
		return url;
	} else {
		return server_url + "/" + url;
	}
};

//Request interceptor
axios.interceptors.request.use(
	function (config) {
		//If header is not set default header json will be used
		if (!config.headers["Content-Type"]) {
			config.headers["Content-Type"] = `application/json`;
		}
		//Allow cookies to be sent with the request
		config.withCredentials = true;
		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

//Response interceptor
axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error?.response?.status === 401) {
			//Force Logout when cookie expires
			localStorage.removeItem("configuration");
			window.location.href = "/login";
		}
		return Promise.reject(error);
	}
);

const post = (url, data, cb, config = {}) => {
	url = getOrigin(url);
	axios
		.post(url, data, config)
		.then((res) => {
			cb(res.data);
		})
		.catch((err) => {
			console.log(err);
			cb(null, err);
		});
};

const asyncPost = async (url, data, config = {}) => {
	url = getOrigin(url);
	const res = await axios.post(url, data, config);
	return res.data;
};

const get = (url, params, cb, config = {}) => {
	url = getOrigin(url);
	axios
		.get(url, { params, ...config })
		.then((res) => {
			cb(res.data);
		})
		.catch((err) => {
			cb(null, err);
		});
};

const patch = (url, data, cb, config = {}) => {
	url = getOrigin(url);
	axios
		.patch(url, data, config)
		.then((res) => {
			cb(res.data);
		})
		.catch((err) => {
			cb(null, err);
		});
};

const deleteRequest = (url, data, cb, config = {}) => {
	url = getOrigin(url);
	axios
		.delete(url, { data, ...config })
		.then((res) => {
			cb(res.data);
		})
		.catch((err) => {
			cb(null, err);
		});
};

const uploadFile = async (file, cb) => {
	if (file) {
		const dismissToast = Toast.loading("Uploading...");
		const formData = new FormData();
		formData.append("file", file);
		formData.append("name", file.name);
		axios
			.post(getOrigin(`/upload/file`), formData, {
				headers: {
					"Content-Type": "multipart/form-data",
					withCredentials: true,
				},
			})
			.then((res) => {
				dismissToast();
				cb(res.data);
			})
			.catch((err) => {
				dismissToast();
				cb(undefined, err);
			});
	}
};

const uploadFileToUrl = async (file, url, data, cb) => {
	if (file) {
		const dismissToast = Toast.loading("Uploading...");
		const formData = new FormData();
		formData.append("file", file);
		formData.append("name", file.name);
		//Append data to form
		Object.keys(data).forEach((key) => {
			formData.append(key, data[key]);
		});
		axios
			.post(getOrigin(url), formData, {
				headers: { "Content-Type": "multipart/form-data", withCredentials: true },
			})
			.then((res) => {
				dismissToast();
				cb(res.data);
			})
			.catch((err) => {
				dismissToast();
				cb(undefined, err);
			});
	}
};

export { post, get, patch, deleteRequest, uploadFile, uploadFileToUrl, apis, asyncPost };
